module.exports = __webpack_public_path__ + "static/media/chat-flows.62942a37.webp";